"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e={defaultProps:{variant:"body2"},styleOverrides:{root:({theme:t})=>({fontWeight:t.typography.fontWeightBold})}};exports.LINK_OVERRIDES=e;
//# sourceMappingURL=link.js.map
